<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-08-11 23:25:21
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-15 17:17:52
 * @FilePath: \jsczt_vue\src\views\indexs.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- window.open('/yjsgk', '_self') -->
<template>
    <div>

    </div>
</template>
<script>
export default{
  created () {
    window.open('/yjsgk', '_self')
  }
}
</script>
<style scoped>
::v-deep .el-input__icon {
  line-height: 0px !important;
}
 .el-input__suffix {
    margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/indexs.vue